import { t } from "i18next";
import { ICON_BASE_PATH } from "../../../../utils/config";
import { TextBox, type TextBoxChangeEvent } from "@progress/kendo-react-inputs";

interface TradeLicenseNumberProps {
  label: string;
  value: string;
  onChange: (e: string) => void;
  validationMessage?: string;
  showStarLabel?: boolean;
  max?: number;
  minLength?: number;
  disable?: boolean;
  prefix?: string;
  cityCode?: string;
}

const TradeLicenseNumber: React.FC<TradeLicenseNumberProps> = ({
  label,
  value,
  onChange,
  validationMessage,
  showStarLabel = true,
  max = 30,
  minLength = 14,
  disable = false,
}) => {

  
  const sanitize = (text: string) =>
    text
      .replace(/[^a-zA-Z0-9]/g, "")
      .toUpperCase()
      .slice(0, max);

  const handleChange = (e: TextBoxChangeEvent) => {
    const inputValue = sanitize(String(e.value ?? ""));
    onChange(inputValue);
  };

  const displayValue = value || "";

  return (
    <div className="gx_input_container">
      <label
        className={`input-label gx-font-semibold ${value ? "floating" : ""}`}
      >
        {t(label)}
        {showStarLabel && (
          <span
            className={`gx_input_star ${
              value ? "gx_input_star_float" : "gx_input_star_normal"
            }`}
          >
            *
          </span>
        )}
      </label>

      <div
        className={`gx_input_cont ${validationMessage ? "invalid" : "valid"}`}
      >
        <img src={`${ICON_BASE_PATH}trade.svg`} alt="Trade License" />

        <TextBox
          value={displayValue}
          onChange={handleChange}
          type="text"
          autoComplete="off"
          disabled={disable}
          className="gx-textbox-css"
          maxLength={max}
        />
      </div>

      {validationMessage && (
        <div className="gx_input_validationmessage">{validationMessage}</div>
      )}

      {!validationMessage &&
        value &&
        value.length > 0 &&
        value.length < minLength && (
          <div className="gx_input_validationmessage">
            Trade License Number must be between {minLength} and {max}{" "}
            characters.
          </div>
        )}
    </div>
  );
};

export default TradeLicenseNumber;
